import { useState, useEffect } from 'react';
import {
  useMediaQuery, Grid,
  Box,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { hotjar } from 'react-hotjar';
import SideBarMenu from './SideBarMenu';
import logoCredicuotasDesktop from '../../images/logo_credicuotas_desktop.svg';
import logoCredicuotasMobile from '../../images/logo_credicuotas_mobile.svg';
import i18n from '../common/i18n';
import NavBar from './NavBar';
import '../../assests/css/headerStyle.css';
import { route } from '../navigation/routes';
import {
  ENVIRONMENT, getEnv,
} from '../../api/env';
import { useIsMobile } from '../../utils/functionUtils';

const analytics = () => {
  const location = useLocation().pathname;
  const hjid = 5308135;
  const hjsv = 6;

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        path: location,
      },
    });
    ReactGA.pageview(location);
    ReactPixel.pageView(location);
    hotjar.initialize({ id: hjid, sv: hjsv });
  }, [location]);
};

const Header = () => {
  const matchesMobile = useMediaQuery('(max-width: 1264px)');
  const [hide, setHide] = useState(false);
  const location = useLocation();
  const pathToExcludeHeader = [
    route.whatsapp.toLowerCase(),
    route.uber.toLowerCase(),
    route.branch.toLowerCase(),
    route.recharge.toLowerCase(),
    route.services.toLowerCase(),
    route.cellphoneRecharge.toLowerCase(),
  ];
  const isMobile = useIsMobile();
  const ENV = getEnv(ENVIRONMENT);
  if (ENV === 'UAT' || ENV === 'PRD') {
    analytics();
  }
  const init = () => {
    const hideHeader = pathToExcludeHeader.includes(location.pathname.toLowerCase());
    setHide(hideHeader);
  };

  useEffect(() => init(), [location.pathname]);

  return (
    <>
      <div className="header">
        {!hide && (
          <header style={{ backgroundColor: 'white', height: (isMobile ? '50px' : '58px') }}>
            <Grid container>
              <Grid item xs={10} md={2} className="gridLogoHeader">
                <Link
                  to={{ pathname: '/' }}
                  style={{ textDecoration: 'none' }}
                >
                  <img
                    src={matchesMobile ? logoCredicuotasMobile : logoCredicuotasDesktop}
                    alt={i18n.credicuotas}
                    className="logoHeader"
                  />
                </Link>
              </Grid>
              {
                matchesMobile ? (
                  <>
                    <Grid item md={8} />
                    <Grid item xs={2} md={2}>
                      <nav className="nav-area menuHamburguesa">
                        <SideBarMenu />
                      </nav>
                    </Grid>
                  </>
                ) : (
                  <Grid item md={10}>
                    <nav className="nav-area">
                      <NavBar />
                    </nav>
                  </Grid>
                )
              }
            </Grid>
          </header>
        )}
      </div>
      <Box mb={isMobile ? '0px' : '58px'} />
    </>
  );
};

export default Header;
